import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BackendCallService } from 'src/app/services/backend-call/backend-call.service';
import { appLanguageLabels } from 'src/app/utilities/constant';

@Component({
  selector: 'app-view-screen',
  templateUrl: './view-screen.component.html',
  styleUrls: ['./view-screen.component.scss'],
})
export class ViewScreenComponent implements OnInit {

  @Input() title: any;
  @Input() componentId: any;
  @Input() parameterId: any;
  @Input() showEdit: boolean;
  @Output() onBtnClick = new EventEmitter<string>();
  @Output() onCancelClick = new EventEmitter<string>();
  public componentDetails = [];
  public headers = [];
  public values = [];
  constructor(private backendCallService: BackendCallService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.getViewComponentDetails();
  }

  private getViewComponentDetails() {
    this.backendCallService.getViewComponentDetails(this.componentId, this.parameterId).subscribe(
      (data: any) => {
        this.componentDetails = data.response;
        this.headers = this.componentDetails[0];
        this.values = this.componentDetails[1];

        this.values.forEach(element => {
          if (element?.FieldName == 'Language' && element?.FieldValue) {
            const languageCode = element.FieldValue.toLowerCase();
            element.FieldValue = appLanguageLabels[languageCode] || element.FieldValue;
          }
        });          
      },
      (error) => {
        console.error('Error in fetching component details:', error);
      }
    );
  }

  public onUserAction() {
    this.onBtnClick.emit();
  }

  public onCancel() {
    this.onCancelClick.emit();
  }

}
